import { InstructionalFeature } from "./InstructionalFeature";

export { InstructionalFeature };
